/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["subscriptions-list .admin-table-panel .mat-table .mat-column-edit{flex:0 0 120px}"];
export { styles as styles };
